import { TicketStatus } from '@nemuru-eng/js-api-client';
import React from 'react';

import { StatusTagType } from '../../../../../../../../config/types';
import { StatusTag } from '../../../../../../../shared/components/StatusTag/StatusTag';

interface TicketStatusTagProps {
  status: TicketStatus;
}
export const TicketStatusTag = ({ status }: TicketStatusTagProps) => {
  const TicketStatusParams = {
    [TicketStatus.SOLVED]: {
      type: StatusTagType.SUCCESS,
      textId: 'TICKET_SOLVED',
    },
    [TicketStatus.CLOSED]: {
      type: StatusTagType.DEFAULT,
      textId: 'TICKET_CLOSED',
    },
    [TicketStatus.OPEN]: {
      type: StatusTagType.INFO,
      textId: 'TICKET_OPENED',
    },
    [TicketStatus.PENDING]: {
      type: StatusTagType.WARNING,
      textId: 'TICKET_PENDING',
    },
    [TicketStatus.NEW]: {
      type: StatusTagType.INFO,
      textId: 'TICKET_NEW',
    },
  };

  return <StatusTag type={TicketStatusParams[status].type} labelTextId={TicketStatusParams[status].textId} />;
};
